import { useEffect, useRef } from 'react';
import {
  useEnrollToEduCourseDateMutation,
  useUnenrollFromEduCourseDateMutation,
} from '../redux/services/eduCourseDates';
import { useToastMessages } from './useToastMessages.jsx';
import { useTranslation } from 'react-i18next';

export function useCourseDateEnrollMutations({
  onEnrollmentChange = () => {},
  onSuccessEnrollToDate = () => {},
  onSuccessLeaveFromDate = () => {},
}) {
  const [
    enrollToCourseDate,
    {
      isSuccess: isSuccessEnrollCourseDate,
      isError: isErrorEnrollCourseDate,
      error: enrollError,
      requestId: enrollRequestId,
      reset: resetEnroll,
    },
  ] = useEnrollToEduCourseDateMutation();

  const [
    unenrollFromCourseDate,
    {
      isSuccess: isSuccessLeaveCourseDate,
      isError: isErrorLeaveCourseDate,
      error: leaveError,
      requestId: leaveRequestId,
      reset: resetUnenroll,
    },
  ] = useUnenrollFromEduCourseDateMutation();

  const lastHandledEnrollReqIdRef = useRef(null);
  const lastHandledLeaveReqIdRef = useRef(null);

  const { successMessage, apiErrorMessage } = useToastMessages();
  const { t } = useTranslation();

  useEffect(() => {
    // success
    if (isSuccessEnrollCourseDate && enrollRequestId) {
      if (lastHandledEnrollReqIdRef.current === enrollRequestId) return;
      lastHandledEnrollReqIdRef.current = enrollRequestId;

      onEnrollmentChange();
      onSuccessEnrollToDate();
      successMessage({ message: t('Prihlásenie na termín prebehlo úspešne') });
      resetEnroll?.();
    }

    // error
    if (isErrorEnrollCourseDate && enrollRequestId) {
      if (lastHandledEnrollReqIdRef.current === enrollRequestId) return;
      lastHandledEnrollReqIdRef.current = enrollRequestId;

      apiErrorMessage(enrollError);
      resetEnroll?.();
    }
  }, [
    isSuccessEnrollCourseDate,
    isErrorEnrollCourseDate,
    enrollRequestId,
    enrollError,
    onEnrollmentChange,
    onSuccessEnrollToDate,
    successMessage,
    apiErrorMessage,
    t,
  ]);

  useEffect(() => {
    // success
    if (isSuccessLeaveCourseDate && leaveRequestId) {
      if (lastHandledLeaveReqIdRef.current === leaveRequestId) return;
      lastHandledLeaveReqIdRef.current = leaveRequestId;

      onEnrollmentChange();
      onSuccessLeaveFromDate();
      successMessage({ message: t('Odhlásenie z termínu prebehlo úspešne') });
      resetUnenroll?.();
    }

    // error
    if (isErrorLeaveCourseDate && leaveRequestId) {
      if (lastHandledLeaveReqIdRef.current === leaveRequestId) return;
      lastHandledLeaveReqIdRef.current = leaveRequestId;

      apiErrorMessage(leaveError);
      resetUnenroll?.();
    }
  }, [
    isSuccessLeaveCourseDate,
    isErrorLeaveCourseDate,
    leaveRequestId,
    leaveError,
    onEnrollmentChange,
    onSuccessLeaveFromDate,
    successMessage,
    apiErrorMessage,
    t,
  ]);

  return {
    enrollToCourseDate,
    unenrollFromCourseDate,
  };
}
